
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitosambhajinagar() {



    const cardData =
    {
        keyword: 'Mumbai to Sambhajinagar Cab',
        heading: 'S9 Travels: Mumbai to Sambhajinagar Cab',
        headingDescription: 'S9 Travels offers Mumbai to Sambhajinagar (Aurangabad) Cab Service, ensuring a comfortable, safe, and hassle-free journey. Whether you are traveling for business, tourism, or a family trip, our well-maintained cabs, including spacious Innova vehicles, provide a smooth and enjoyable ride. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Mumbai to Sambhajinagar (Aurangabad) Cab with S9 Travels and experience a stress-free journey!',


        top: 'Top Places to Visit in Sambhajinagar with S9 Travels',

"topPlaces": [
    {
      "title": "Ajanta Caves",
      "description": "A UNESCO World Heritage Site, the Ajanta Caves are a collection of 29 rock-cut Buddhist caves known for their stunning murals and sculptures. Dating back to the 2nd century BCE, these caves depict stories from the life of Buddha and are a masterpiece of ancient Indian art."
    },
    {
      "title": "Ellora Caves",
      "description": "Another UNESCO World Heritage Site, the Ellora Caves consist of 34 rock-cut temples belonging to Hinduism, Buddhism, and Jainism. The most famous attraction is the Kailasa Temple, an enormous monolithic rock-cut structure dedicated to Lord Shiva."
    },
    {
      "title": "Bibi Ka Maqbara",
      "description": "Often referred to as the 'Mini Taj Mahal,' Bibi Ka Maqbara was built by Aurangzeb’s son, Azam Shah, in memory of his mother, Dilras Banu Begum. The monument closely resembles the Taj Mahal and is a major attraction in Aurangabad."
    },
    {
      "title": "Daulatabad Fort",
      "description": "Originally known as Devagiri Fort, Daulatabad Fort is a massive hilltop fortress known for its impressive defense mechanisms, secret escape routes, and the Chand Minar. The fort offers panoramic views of the surrounding landscape."
    },
    {
      "title": "Grishneshwar Temple",
      "description": "One of the 12 Jyotirlingas of Lord Shiva, Grishneshwar Temple is a significant pilgrimage site for Hindus. It is located near the Ellora Caves and showcases beautiful stone carvings and ancient temple architecture."
    },
    {
      "title": "Panchakki",
      "description": "A historic water mill built in the 17th century, Panchakki was used to grind grain for the Sufi saints. It features an underground water channel system that powers the mill, along with a serene garden and a mosque."
    },
    {
      "title": "Siddharth Garden and Zoo",
      "description": "A popular attraction for families and nature lovers, Siddharth Garden features lush greenery and a zoo housing tigers, lions, crocodiles, and various bird species. It’s a great place for a leisurely evening outing."
    },
    {
      "title": "Aurangabad Caves",
      "description": "A lesser-known yet fascinating group of 12 Buddhist caves, the Aurangabad Caves date back to the 6th and 7th centuries. They feature intricate sculptures, stupas, and carvings influenced by Buddhist teachings."
    },
    {
      "title": "Salim Ali Lake & Bird Sanctuary",
      "description": "Named after the famous ornithologist Dr. Salim Ali, this lake and bird sanctuary is a peaceful spot for birdwatching. It attracts migratory birds and offers a scenic retreat from the city's hustle and bustle."
    },
    {
      "title": "Himayat Bagh",
      "description": "Spread over 400 acres, Himayat Bagh is a beautiful Mughal-style garden featuring lush greenery, fountains, and a nursery. It is a perfect place for a relaxed stroll and photography."
    }
],

"services": [
  {
    "name": "Mumbai to Sambhajinagar (Aurangabad) Cab Service",
    "description": "Book a reliable and comfortable cab from Mumbai to Sambhajinagar (Aurangabad) with S9 Travels. Our services include both one-way and round-trip options, ensuring that your journey is safe, comfortable, and efficient. Whether you're traveling for business or leisure, our experienced drivers and well-maintained vehicles will make your trip to this historical city seamless and enjoyable."
  },
  {
    "name": "Book Mumbai to Aurangabad Taxi",
    "description": "Booking a taxi from Mumbai to Aurangabad is simple and hassle-free with S9 Travels. We offer flexible options to suit your needs, whether you’re traveling one-way or prefer the convenience of a round trip. Our fleet of clean, well-maintained cars ensures that you travel comfortably, and our experienced chauffeurs guarantee a smooth, timely ride to this culturally rich city."
  },
  {
    "name": "Affordable Mumbai to Sambhajinagar Cab",
    "description": "Looking for an affordable way to travel from Mumbai to Sambhajinagar (Aurangabad)? S9 Travels offers cost-effective cab services that don’t compromise on comfort or safety. With our budget-friendly options, you can enjoy a pleasant journey without breaking the bank. Our experienced drivers ensure you reach your destination safely and on time."
  },
  {
    "name": "Private Taxi for Aurangabad from Mumbai",
    "description": "Travel privately and comfortably with a dedicated taxi from Mumbai to Aurangabad. Whether you’re traveling solo or with a group, our private taxis provide the perfect solution for your journey. Choose from a variety of vehicles based on your preferences, and enjoy a relaxed and smooth ride to this iconic historical city."
  },
  {
    "name": "Mumbai to Aurangabad One-Way or Round Trip",
    "description": "S9 Travels offers both one-way and round-trip taxi services from Mumbai to Aurangabad. Whether you need a quick one-way trip or the flexibility of a round trip, we provide customized options to meet your needs. Our professional drivers and well-maintained vehicles ensure that your journey is safe, comfortable, and tailored to your travel schedule."
  },
  {
    "name": "Luxury Cab from Mumbai to Sambhajinagar",
    "description": "Experience luxury travel with S9 Travels’ premium cabs from Mumbai to Sambhajinagar (Aurangabad). Our luxury vehicles offer high-end comfort, privacy, and convenience, making your journey to this historic city a relaxing and stylish experience. With top-notch amenities and professional chauffeurs, enjoy a ride that’s second to none."
  },
  {
    "name": "Comfortable Travel from Mumbai to Aurangabad",
    "description": "Travel comfortably from Mumbai to Aurangabad with S9 Travels. Our well-maintained cars, combined with the expertise of our drivers, ensure a smooth and relaxing ride. Whether you are traveling for business or leisure, we prioritize your comfort and safety, making your journey a pleasant one from start to finish."
  },
  {
    "name": "Aurangabad Sightseeing by Taxi",
    "description": "Explore Aurangabad’s historical and cultural sites with a taxi from S9 Travels. Whether you're visiting the Ajanta and Ellora Caves, the Bibi Ka Maqbara, or other attractions, our knowledgeable drivers will guide you on a sightseeing tour that covers the best the city has to offer. Enjoy a personalized and flexible tour that suits your interests and schedule."
  },
  {
    "name": "Group Travel to Aurangabad from Mumbai",
    "description": "Planning a group trip to Aurangabad from Mumbai? S9 Travels offers spacious vehicles that can comfortably accommodate large groups. Our experienced drivers ensure a smooth and safe journey for everyone, while our vehicles provide the comfort and space needed for an enjoyable group travel experience to Aurangabad."
  },
  {
    "name": "Sambhajinagar (Aurangabad) Trip by Cab",
    "description": "Book a taxi for your trip from Mumbai to Sambhajinagar (Aurangabad) with S9 Travels. Whether you are visiting for business, leisure, or sightseeing, our dedicated taxi services offer flexibility and comfort. With experienced drivers and well-maintained cars, we ensure a comfortable and timely journey to and from this historic city."
  }
],

"tableData": [
  ["Mumbai to Sambhajinagar (Aurangabad) Cab Service", "Book Mumbai to Aurangabad Taxi"],
  ["Affordable Mumbai to Sambhajinagar Cab", "Private Taxi for Aurangabad from Mumbai"],
  ["Mumbai to Aurangabad One-Way or Round Trip", "Luxury Cab from Mumbai to Sambhajinagar"],
  ["Comfortable Travel from Mumbai to Aurangabad", "Aurangabad Sightseeing by Taxi"],
  ["Group Travel to Aurangabad from Mumbai", "Sambhajinagar (Aurangabad) Trip by Cab"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Sambhajinagar (Aurangabad) cab service, ideal for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Mumbai to Sambhajinagar (Aurangabad) cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Mumbai to Sambhajinagar (Aurangabad). They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Mumbai to Sambhajinagar (Aurangabad) cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Sambhajinagar Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Mumbai to Sambhajinagar (Aurangabad)."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Mumbai to Sambhajinagar (Aurangabad) trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Sambhajinagar Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Mumbai to Sambhajinagar (Aurangabad) journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to Sambhajinagar (Aurangabad) cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]


















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Sambhajinagar (Aurangabad) with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Sambhajinagar (Aurangabad) is easy! You can book your ride via our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and stress-free journey to Sambhajinagar (Aurangabad).',
          },
          {
            question: 'What types of vehicles are available for a trip from Mumbai to Sambhajinagar (Aurangabad)?',
            answer: 'We offer a variety of vehicles for your trip from Mumbai to Sambhajinagar (Aurangabad), including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best suits your needs based on your group size and preferences.',
          },
          {
            question: 'Are the drivers experienced for the Mumbai to Sambhajinagar (Aurangabad) trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Mumbai to Sambhajinagar (Aurangabad) journey. They prioritize your safety, comfort, and a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Mumbai to Sambhajinagar (Aurangabad)?',
            answer: 'Yes, you can book a round-trip cab for your journey from Mumbai to Sambhajinagar (Aurangabad). Simply provide us with your return details, and we will ensure a smooth return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Mumbai to Sambhajinagar (Aurangabad)?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to secure vehicle availability. However, last-minute bookings are also possible based on availability.',
          },
          {
            question: 'Is there a fixed fare for the Mumbai to Sambhajinagar (Aurangabad) cab service?',
            answer: 'The fare for the Mumbai to Sambhajinagar (Aurangabad) trip depends on the distance, vehicle type, and other specific requirements. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Mumbai airport or hotels for the Sambhajinagar (Aurangabad) trip?',
            answer: 'Yes, we offer convenient pick-up services from Mumbai airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Sambhajinagar (Aurangabad).',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Sambhajinagar (Aurangabad)?',
            answer: 'Yes, we can customize your itinerary by adding stops for meals, sightseeing, or other breaks during your journey to Sambhajinagar (Aurangabad). Inform us at the time of booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Sambhajinagar (Aurangabad) trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process. We maintain full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Sambhajinagar (Aurangabad) trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Mumbai to Sambhajinagar (Aurangabad). With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Sambhajinagar (Aurangabad) with S9 Travels, and the experience was fantastic. The driver was courteous and professional, and the vehicle was clean and comfortable. The journey was smooth, and we arrived in Sambhajinagar (Aurangabad) on time. I highly recommend S9 Travels for long-distance trips!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Mumbai to Sambhajinagar (Aurangabad) with S9 Travels was amazing. The vehicle was spacious and well-maintained, and the driver was skilled and friendly. We enjoyed the scenic route, and the entire trip was very comfortable. We will definitely use S9 Travels again for future journeys!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Sambhajinagar (Aurangabad) Cab",
        "description": "Book affordable and reliable Mumbai to Sambhajinagar (Aurangabad) cab services for one-way trips, round trips, and luxury rides. S9 Travels offers private taxi services for a comfortable and scenic journey from Mumbai to Aurangabad, ideal for sightseeing, group travel, and exploring the city's historical landmarks.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
    
      


    return (
        <div>
          
      <Helmet>
        <title>Mumbai to Sambhajinagar (Aurangabad) Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Sambhajinagar (Aurangabad) taxi services, including one-way, round-trip, and private cabs. Comfortable and affordable transport for sightseeing tours, group travel, and exploring Aurangabad from Mumbai with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitosambhajinagar;